// Navigation configuration for the authenticated Workspace platform.
export const PRIMARY_NAV = [
  { label: "Command Center", to: "/app", icon: "LayoutDashboard", end: true },
  { label: "Board", to: "/app/board", icon: "Landmark" },
  { label: "Goals", to: "/app/goals", icon: "Target" },
  { label: "Work", to: "/app/work", icon: "CheckSquare" },
  { label: "Sales", to: "/app/sales", icon: "Contact" },
  { label: "Projects", to: "/app/projects", icon: "FolderKanban" },
  { label: "Calendar", to: "/app/calendar", icon: "Calendar" },
  { label: "Data", to: "/app/data", icon: "Database" },
  { label: "Meeting Assist", to: "/app/meeting", icon: "NotebookPen" },
];

// Future modules — rendered as disabled "Soon" items so the shell is future-ready.
export const MODULE_NAV = [
  { label: "Documents", icon: "FileText" },
  { label: "Reports", icon: "BarChart3" },
  { label: "Integrations", icon: "Plug" },
];

export const FOOTER_NAV = [
  { label: "Settings", to: "/app/settings", icon: "Settings" },
  { label: "Help & Feedback", to: "/app/help", icon: "LifeBuoy" },
];
